<template>
    <Card  containerClass="mb-5">
      <div class="card-header">
        <div class="card-title"> </div>
        <div class="card-toolbar" >
          <Button type="new" v-if="$can(abilities.CREATE_PENSION)" btn-class="me-3 btn-sm" btn-text="pension.add"  @click="openCreateModal" ></Button>
        </div>
      </div>
      <template #cardBody>
        <table class="table align-middle table-row-bordered fs-6 gy-3 gx-4" id="kt_datatable_pensions" style="margin-top: 13px !important; cursor:pointer">
          <thead style="background-color: #F2F3F4;">
          <tr class="fw-bold fs-6" style="background-color: #F2F3F4;">
            <th class=" px-4 ">{{$t("pension.category")}}</th>
            <th class=" px-4 ">{{$t("pension.title")}}</th>
            <th class=" px-4 ">{{$t("pension.bracket")}}</th>
            <th class=" px-4 ">{{$t("pension.value")}}</th>
            <th>{{$t("actions")}}</th>
          </tr>
          </thead>
        </table>
      </template>
    </Card>

    <UpdatePensionModal id="edit_pension" :formEdit="formEdit" @reloadDatatable="reloadDatatable" />
    <NewPensionModal id="create_pension" @reloadDatatable="reloadDatatable" />
</template>

<script setup>

import {ref,onMounted,watch , nextTick} from "vue";[[]]
import {BASE_URL} from "@/services/api";
import {useStore} from "vuex";
import Ls from "@/services/ls";
import { useI18n } from 'vue-i18n'
import { useLocales } from '@/composables/locales';
import Button from "@/components/Button.vue";
import Card from "@/Modules/CRM/components/Card";
import {Theme} from "@/composables/theming";
import {useSwal} from "@/composables/useSwal";
import {useHasAbility} from "@/composables/hasAbility";
import UpdatePensionModal from "./components/UpdatePensionModal.vue";
import NewPensionModal from "./components/NewPensionModal.vue";
import { useFormatAmount } from "@/composables/formatAmount";
import { computed } from "vue";
import abilities from "@/composables/abilities";

const table = ref(null)
const formEdit = ref({})
const store = useStore()

const { t } = useI18n({ useScope: 'global' })
const {locale, datatableLocaleUrl} = useLocales()
const {showSwal} = useSwal()
const { can } = useHasAbility()
const { formatAmount, formatNumber } = useFormatAmount()

const currentSociety = computed(() => store.getters['offices/getSelectedCompany'])

function openCreateModal(){
  $('#create_pension').modal('toggle')
}

function openEditModal(){
  $('#edit_pension').modal('toggle')
}

function fetchDatas() {

      const AUTH_TOKEN = Ls.get('auth.token')
      const pageLimit = Ls.get('pageLength')

      table.value = $("#kt_datatable_pensions").DataTable({
        destroy : true,
        responsive: !0,
        searchDelay: 500,
        processing: !0,
        serverSide: !0,
        pageLength:pageLimit ||  5,
        lengthMenu: [5, 10, 25, 50, 75, 100 ],
        order: [[ 0, 'desc']],
        ajax: {
          url: BASE_URL+"/get/pension/datatables",
          type: "GET",
          beforeSend: function (request) {
            request.setRequestHeader("Authorization", "Bearer " + AUTH_TOKEN);
            request.setRequestHeader("Company", Ls.get('current.company'));
            },
          data:  function ( d ) {

          }
        },
        columns: [{data: "category"},{data: "title"},{data: "title"},{data: "title"}, {data: "Actions", responsivePriority: -1}],

        columnDefs: [
          
          {
              targets: -5,
              render: function (t, a, e, l) {
                  return '<span class="nameRow' + l.row + '">' + t + "</span>";
              },
          },
          {
              targets: -4,
              orderable: !1,
              render:  (t, a, e, l) =>  {
                return '<span class="nameRow' + l.row + '">' + t + "</span>";
              },
          },
          {
              targets: -3,
              orderable: !1,
              className: "dt-center clickable",
              render:  (t, a, e, l) =>  {
                  let result = ''
                  e.data?.forEach((item, key) => {
                  
                      if(item.range_min && item.range_max ){
                          result += '<span>['+ formatAmount(item.range_min) + ' : '+ formatAmount(item.range_max) + ']  </span>';
                      }else if(!item.range_min && !item.range_max ){

                      }else if(item.range_min && !item.range_max ){
                          result += '<span><= '+ formatAmount(item.range_min) + '  </span>';

                      }else if(!item.range_min && item.range_max ){
                          result += '<span>> '+ formatAmount(item.range_max) + '  </span>';
                      }
                      if(key+1 !== e.data?.length){
                      result += '<div class="mt-5 mb-5 row border-bottom"></div>';
                    }
                  } );

                  return result

              }
          },

          {
              targets: -2,
              orderable: !1,
              className: "dt-center clickable",
              render:  (t, a, e, l) =>  {
                  let result = ''
                  e.data?.forEach((item, key) => {
                    if (item.type === 'percent') {
                        result += '<span>'+ formatNumber(item.value) + ' %</span>';
                    } else {
                        result += '<span>'+ formatAmount(item.value) +  '</span>';
                    }
                    if(key+1 !== e.data?.length){
                      result += '<div class="mt-5 mb-5 row border-bottom"></div>';
                    }
                  } );
                 
                  return result

              }
          },

          {
            width: "16%",
            targets: -1,
            "className": "dt-center",
            title: "Actions",
            orderable: !1,
            render: (t, a, e, l) => {
              let render = '';
              if(can(abilities.UPDATE_PENSION)) {
                if (true) render += `<a href="javascript:;"
                   data-row="${l.row}" 
                   data-id="${e.id}" 
                   data-category="${e.category}" 
                   data-title="${e.title}"  
                   data-society_id="${e?.society_id}"  
                   data-contents='${JSON.stringify(e?.data)}' 
                   class="btn btn-sm btn-clean btn-icon edit_btn" 
                   title="${i18n.global.t('button.edit')}">
                   <i data-row="${l.row}" 
                      data-id="${e.id}" 
                      data-category="${e.category}" 
                      data-title="${e.title}"  
                      data-contents='${JSON.stringify(e?.data)}' 
                      class="fas fa-edit fs-2"  
                      style="color: ${Theme.gray}"></i>
                </a>`;
              }
              if(can(abilities.DELETE_PENSION)) {
                if (true) render += `<a href="javascript:;" data-row="${l.row}" data-id="${e.id}" class="btn btn-sm btn-clean btn-icon delete_btn" title="${i18n.global.t('button.delete')}"><i data-row="${l.row}" data-id="${e.id}" class="fas fa-trash fs-2" style="color: ${Theme.gray}"></i></a>`;
              }
              return render;
            },
          },

        ],
        language: {
          url:  datatableLocaleUrl.value
        }
      });

      $(document).on("click", "#kt_datatable_pensions .edit_btn", (e) => {
        formEdit.value.id = e.target.getAttribute('data-id')
        formEdit.value.society_id= e.target.getAttribute('data-society_id') ?? currentSociety.value?.id,
        formEdit.value.title = e.target.getAttribute('data-title')
        formEdit.value.category = e.target.getAttribute('data-category')
        formEdit.value.pension_data = JSON.parse(e.target.getAttribute('data-contents')) ?? [{
          type: 'amount',
          value: 0,
          range_min: '',
          range_max: ''
        }]

        openEditModal()
      });
}

function reloadDatatable(){
  table.value.ajax.reload()
}

$(document).on("click", "#kt_datatable_pensions .delete_btn", (e) => {
  deletePension(e.target.getAttribute('data-id'))
});


async function deletePension(id){
  showSwal(
      t('swal.pension'),
      t('swal.pension_text')
  ).then( async (result) => {
    if (result.value) {
      try {
        await store.dispatch('pensions/deletePension', id)
        reloadDatatable()
        window.toastr.success(t('notification.pension_deleted'))
      } catch (e) {
      }
    }
  });
}

watch(() => locale.value, () => {
  nextTick(()=>   fetchDatas())
})

onMounted(() => {
  store.dispatch("pensions/loadPensionTypeEnum")
  fetchDatas()
})

</script>
<style>
.end{
  display: flex;
  justify-content: end;
} 
</style>